<!--
 * @Author: zhang_fly 15620636416@163.com
 * @Date: 2023-07-17 16:28:33
 * @LastEditors: zhang_fly 15620636416@163.com
 * @LastEditTime: 2023-08-07 14:11:40
 * @FilePath: /h5/src/views/OperationRecordsView.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE


 使用记录（usage_records）:ID、店铺ID（shop_id）、使用者ID（user_id）、使用模式（mode，模式一为1，模式二为2）。
-->
<template>
  <v-app>
    <v-main>
      <v-app-bar color="teal accent-4" dark app>
        <v-app-bar-nav-icon @click="$router.go(-1)">
          <v-icon>chevron_left</v-icon>
        </v-app-bar-nav-icon>

        <v-toolbar-title>员工列表</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-app-bar-nav-icon :to="{ path: '/staff_detail' }">
          <v-icon>add_circle_outline</v-icon>
        </v-app-bar-nav-icon>
      </v-app-bar>
      <v-card class="mt-4 mb-4 ml-2 mr-2" flat>
        <vue-loadmore
          :on-refresh="onRefresh"
          :on-loadmore="onLoad"
          :finished="finished"
          load-offset="100"
        >
          <template v-for="(item, index) in datalist">
            <v-divider v-if="index != 0" :key="index"></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon color="primary" v-if="item.state">check</v-icon>
                   <v-icon color="error" v-if="!item.state">close</v-icon>
                  {{ item.name }}({{roleText[item.role]}})
                </v-list-item-title >
                <v-list-item-subtitle>
                  <v-icon size="small">phone_iphone</v-icon>
                  {{ item.phone }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  color="primary"
                  elevation="1"
                  rounded
                  text
                  :to="{ path: '/staff_detail', query: { id: item.id } }"
                  small
                >
                  <v-icon dark> edit </v-icon> 详情
                </v-btn>
              </v-list-item-action>
              <v-list-item-action>
                <v-btn
                  color="error"
                  elevation="1"
                  rounded
                  text
                  small
                  @click.stop="deleteDialog(item.id, index)"
                >
                  <v-icon dark> delete </v-icon> 删除
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </vue-loadmore>
      </v-card>
      <v-dialog
        v-model="dialog"
        width="500"
        @click:outside="
          () => {
            this.deleteID = null;
            this.deleteIndex = null;
            this.dialog = false;
          }
        "
      >
        <v-divider></v-divider>
        <v-card>
          <v-card-title color="primary"> 提示 </v-card-title>

          <v-card-text> 确认删除该员工吗？ </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="gray" text @click="cancelDel"> 取消 </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="deletethisstaff()"> 确认 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
    <v-overlay :value="isLoading">
        <v-progress-circular
          indeterminate
          color="primary"
          style="
            position: absolute;
            top: 20%;
            left: 50%;
            transform: translate(-50%, -50%);
          "
          v-if="isLoading"
          size="70"
          :width="3"
        ></v-progress-circular>
      </v-overlay>
  </v-app>
</template>

<script>
import Search from "@/components/Search.vue";
import { staff_list, staff_delete } from "@/api/user.js";
export default {
  name: "StaffList",
  components: {
    Search,
  },
  data: () => ({
    code: null,
    showCamera: false,
    currentTab: 0,
    showSearch: false,
    finished: false,
    currentPage: 1,
    requestList: [],
    condition: [],
    totalPage: 0,
    datalist: [],
    deleteID: null,
    deleteIndex: null,
    dialog: false,
    isLoading: false,
    loadStream: false,
    roleText: ['','店员','管理员']
    
  }),
  created() {
    this.refreshData();
  },
  methods: {
    getData() {
      let params = {
        page: this.currentPage,
        keyword: this.condition.keyword,
      };
      this.isLoading = true;
      staff_list(params)
        .then((res) => {
          this.datalist = this.datalist.concat(res.data.data);
          this.totalPage = res.data.last_page;
          if (res.data.current_page < res.data.last_page) {
            this.currentPage = res.data.current_page + 1;
          } else {
            this.finished = true;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    //清空数据
    clearData() {
      this.datalist = [];
      this.currentPage = 1;
    },
    //重新载入数据
    reloadData() {
      this.clearData();
      this.getData(this.currentTab);
    },

    onRefresh(done) {
      this.reloadData();
      done();
    },
    onLoad(done) {
      this.getData(this.currentTab);
      done();
    },
    refreshData() {
      this.condition = [];
      // this.$refs.search.clear();
      this.reloadData();
    },
    search(data) {
      this.condition = data;
      this.reloadData();
    },
    deleteDialog(id, index) {
      console.log(this.deleteID);
      this.deleteID = id;
      this.deleteIndex = index;
      this.dialog = true;
    },
    cancelDel() {
      this.deleteID = null;
      this.deleteIndex = null;
      this.dialog = false;
    },
    async deletethisstaff() {
      const res = await staff_delete(this.deleteID);
      if (res != null && res.code == 200) {
        this.$toast.success(res.message);
        this.datalist.splice(this.deleteIndex, 1);
      } else {
        this.$toast.error(res.message);
      }
      this.dialog = false;
      console.log(res);
    },
  },
};
</script>

